const state = {
  nav: [
    {
      label: "Planned Maintenance",
      feature: "preventive_maintenance",
      subnav: [
        {
          label: "Scheduling",
          route: "preventative/scheduling",
          view: "scheduling",
        },
        // {
        //   label: "To Assign",
        //   route: "preventative/to_assign",
        //   view: "to_assign",
        // },
        {
          label: "Active PM Work Orders",
          route: "preventative/active_work_orders",
          view: "active_work_orders",
          sidewayDisplay: "PM Work Orders",
        },
        {
          label: "All PM Work Orders",
          route: "preventative/all_work_orders",
          view: "all_work_orders",
          sidewayDisplay: "All PM Work Orders",
        }
      ]
    },
    {
      label: "Corrective Maintenance",
      feature: "corrective_maintenance",
      subnav: [
        {
          label: "Issues",
          route: "corrective/issues",
          view: "issues"
        },
        // {
        //   label: "To Assign",
        //   route: "corrective/to_assign",
        //   view: "to_assign",
        // },
        {
          label: "Active CM Work Orders",
          route: "corrective/active_work_orders",
          view: "active_work_orders",
          sidewayDisplay: "CM Work Orders",
        },
        {
          label: "All CM Work Orders",
          route: "corrective/all_work_orders",
          view: "all_work_orders",
          sidewayDisplay: "All CM Work Orders",
        },
      ]
    },
    {
      label: "Incident Tracking",
      feature: "incident_tracking",
      route: "incident"
    },
    {
      label: "Inventory",
      feature: "inventory",
      subnav: [
        {
          label: "Inventory Items",
          route: "inventory/inventory_items",
          view: "inventory_items"
        },
        {
          label: "Transactions",
          route: "inventory/on_hand_records",
          view: "on_hand_records"
        },
        {
          label: "Maintenance Accounting",
          route: "inventory/maintenance_accounting",
          view: "maintenance_accounting"
        }
      ]
    },
    {
      label: "Assets",
      feature: "assets",
      route: "assets"
    },
    {
      label: "Purchasing",
      feature: "purchasing",
      subnav: [
        {
          label: "Purchase Orders",
          route: "purchasing/purchase_orders",
          view: "purchase_orders"
        },
        {
          label: "Order Receipts",
          route: "purchasing/order_receipts",
          view: "order_receipts",
          sidewayDisplay: "Order Receipts"
        }
      ]
    },
    {
      label: "Manager Tools",
      feature: "manager_tools",
      subnav: [
        {
          label: "Labor Charges",
          route: "manager_tools/labor_charges",
          view: "labor_charges",
        },
        // {
        //   label: "Employee Management",
        //   route: "manager_tools/employee_management",
        //   view: "employee_management",
        // },
        {
          label: "Team Management",
          route: "manager_tools/team_management",
          view: "team_management",
        },
        {
          label: "Define New Procedure",
          route: "manager_tools/define_new_procedure",
          view: "define_new_procedure"
        },
        {
          label: "View & Edit Procedures",
          route: "manager_tools/view_edit_procedures",
          view: "view_edit_procedures",
          sidewayDisplay: "View & Edit Procedures"
        }
      ]
    }
  ]
};
const getters = {
  siteTrackNav: state => state.nav
};

export default {
  state,
  getters
};